import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.state';


@Injectable({
  providedIn: 'root',
})
export class DatabaseService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private store: Store<AppState>,
  ) { }

  getDatabaseList(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/database/list', {withCredentials: true});
  }

  getDatabaseDetails(uuid: string): Observable<any> {
    return this.http
    .get<any>(`${environment.apiUrl}api/v1/database/${uuid}/show`,{ withCredentials: true });
  }
}